import { render } from "./HiringsCustomerDashboard.vue?vue&type=template&id=948cd58e"
import script from "./HiringsCustomerDashboard.vue?vue&type=script&lang=js"
export * from "./HiringsCustomerDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__